/**
 * @generated SignedSource<<93e85ddd75863e85f1678dfe760b0f4f>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Query } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type ReuseQuestionsRequestQuery$variables = {
  id: string;
};
export type ReuseQuestionsRequestQuery$data = {
  readonly node: {
    readonly feedback?: {
      readonly " $fragmentSpreads": FragmentRefs<"ReuseQuestions_feedback">;
    };
  } | null;
};
export type ReuseQuestionsRequestQuery = {
  response: ReuseQuestionsRequestQuery$data;
  variables: ReuseQuestionsRequestQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "id"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "id",
    "variableName": "id"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "ReuseQuestionsRequestQuery",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": null,
        "kind": "LinkedField",
        "name": "node",
        "plural": false,
        "selections": [
          {
            "kind": "InlineFragment",
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "FeedbackNode",
                "kind": "LinkedField",
                "name": "feedback",
                "plural": false,
                "selections": [
                  {
                    "args": null,
                    "kind": "FragmentSpread",
                    "name": "ReuseQuestions_feedback"
                  }
                ],
                "storageKey": null
              }
            ],
            "type": "FeedbackRequestNode",
            "abstractKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "ReuseQuestionsRequestQuery",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": null,
        "kind": "LinkedField",
        "name": "node",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "__typename",
            "storageKey": null
          },
          {
            "kind": "InlineFragment",
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "FeedbackNode",
                "kind": "LinkedField",
                "name": "feedback",
                "plural": false,
                "selections": [
                  (v2/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "title",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "isAnonymous",
                    "storageKey": null
                  }
                ],
                "storageKey": null
              }
            ],
            "type": "FeedbackRequestNode",
            "abstractKey": null
          },
          (v2/*: any*/)
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "6104368dffe18fd0408f1a26cb4be39d",
    "id": null,
    "metadata": {},
    "name": "ReuseQuestionsRequestQuery",
    "operationKind": "query",
    "text": "query ReuseQuestionsRequestQuery(\n  $id: ID!\n) {\n  node(id: $id) {\n    __typename\n    ... on FeedbackRequestNode {\n      feedback {\n        ...ReuseQuestions_feedback\n        id\n      }\n    }\n    id\n  }\n}\n\nfragment ReuseQuestions_feedback on FeedbackNode {\n  id\n  title\n  isAnonymous\n}\n"
  }
};
})();

(node as any).hash = "5deb03f2324707343bf566083d943175";

export default node;
